import { defineComponent } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { downloadChrome } from '@/utils';
export default defineComponent({
  name: 'HeaderTip',
  components: {
    ExclamationCircleOutlined: ExclamationCircleOutlined
  },
  props: {
    tip: {
      type: Number,
      default: 0
    }
  },
  setup: function () {
    return {
      downloadChrome: downloadChrome
    };
  }
});